import { t } from "@lingui/macro";
import { useSetAtom } from "jotai";

import { PatronsListItem } from "@/features/AddPatrons/components/PatronsListItem";

import { enterEditableRoundsPrivateStepAtom } from "../../../../atoms/actions/EnterEditableRoundsPrivateStepAtom/enterEditableRoundsPrivateStepAtom";
import { replacePlayerOnRoundAtom } from "../../../../atoms/actions/replacePlayerOnRoundAtom/replacePlayerOnRoundAtom";
import { PatronEditBooking } from "../../../../types";

type Props = {
  replacingRound: PatronEditBooking.Round | null | undefined;
  membersCanAddUnknownGuests: boolean;
};

export const UnknownGuest = ({
  replacingRound,
  membersCanAddUnknownGuests,
}: Props) => {
  const replacePlayerOnRound = useSetAtom(replacePlayerOnRoundAtom);
  const enterEditableRoundsPrivateStep = useSetAtom(
    enterEditableRoundsPrivateStepAtom
  );

  return membersCanAddUnknownGuests ? (
    <PatronsListItem
      item={{ type: "Unknown Guest", memberGroups: [] }}
      displayName={t`Unknown Guest`}
      selectionAction="replace"
      handleCheck={() => {
        replacePlayerOnRound({
          roundId: replacingRound?.localId ?? "",
          player: {
            id: null,
            clientType: "unknownGuest",
            firstName: null,
            lastName: null,
          },
        });
        enterEditableRoundsPrivateStep();
      }}
    />
  ) : null;
};
